var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetingBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M673.9,209.62c-37.33-32.45-82-54.48-126.28-75.75C498,110,446.15,86.21,393,71.52a402,402,0,0,0-54-11.18c-80.13-10.7-156.82,43.54-212.3,95.25A592.08,592.08,0,0,0,65.19,222.3c-13.67,17.37-30,35.94-35.75,58.18-6.77,26.12,7.38,48,21.49,68.8C62.24,366,74,381.66,88.16,396.07a302.87,302.87,0,0,0,117.35,73.82c82.12,28.11,173.3,17.45,257.66,7.26q7.14-.86,14.26-1.79C529.52,468.57,581.27,464,630.87,445c72-27.55,120.5-108.43,84.46-183C705.47,241.61,691,224.47,673.9,209.62Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.9,209.62c-37.33-32.45-82-54.48-126.28-75.75C498,110,446.15,86.21,393,71.52a402,402,0,0,0-54-11.18c-80.13-10.7-156.82,43.54-212.3,95.25A592.08,592.08,0,0,0,65.19,222.3c-13.67,17.37-30,35.94-35.75,58.18-6.77,26.12,7.38,48,21.49,68.8C62.24,366,74,381.66,88.16,396.07a302.87,302.87,0,0,0,117.35,73.82c82.12,28.11,173.3,17.45,257.66,7.26q7.14-.86,14.26-1.79C529.52,468.57,581.27,464,630.87,445c72-27.55,120.5-108.43,84.46-183C705.47,241.61,691,224.47,673.9,209.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42.53,
    y1: 462.12,
    x2: 729.2,
    y2: 462.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.32,
    cy: 131.04,
    r: 33.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.32,
    cy: 131.04,
    r: 29.94,
    transform: "translate(-27.18 28.62) rotate(-13.28)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.32,
    cy: 131.04,
    r: 2.86,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.74 136.13 109.32 131.04 91.94 150.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.28,
    y: 96.05,
    width: 84.56,
    height: 105.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.05,
    y: 99.5,
    width: 79.04,
    height: 98.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.32,
    y: 128.48,
    width: 32.5,
    height: 40.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamps--inject-6"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 391.59,
    y1: 39.12,
    x2: 391.59,
    y2: 7.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.7 56.03 365.49 56.03 381.15 36.18 402.04 36.18 417.7 56.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 676.08,
    y1: 39.12,
    x2: 676.08,
    y2: 7.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "702.18 56.03 649.97 56.03 665.63 36.18 686.52 36.18 702.18 56.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.11,
    y1: 39.12,
    x2: 107.11,
    y2: 7.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.22 56.03 81.01 56.03 96.67 36.18 117.55 36.18 133.22 56.03",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.38,321.27h0a.1.1,0,0,0,0-.13.1.1,0,0,0-.13.05,129.24,129.24,0,0,0-6.74,21.16,197.64,197.64,0,0,0-3.73,21.93l-.53,5.54c-.08.93-.18,1.85-.24,2.78l-.16,2.78c-.08,1.85-.19,3.71-.24,5.57l0,5.57.06,2.78c0,.93.11,1.86.17,2.78.14,1.85.25,3.71.42,5.55.36,3.7.91,7.37,1.49,11a.09.09,0,0,0,.09.08.09.09,0,0,0,.1-.1h0c0-1.86-.09-3.71-.13-5.56s-.21-3.68-.19-5.53,0-3.68-.06-5.53l0-2.76,0-2.76,0-5.52.15-5.52.06-2.76c0-.92.11-1.84.16-2.75l.33-5.52a196.48,196.48,0,0,1,3.13-21.87A128,128,0,0,1,99.38,321.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17,350.14a.09.09,0,0,0-.06-.12.09.09,0,0,0-.12.06,128.32,128.32,0,0,0-6.25,28.43c-.49,4.83-1,9.66-1.1,14.52a120.2,120.2,0,0,0,.52,14.57.09.09,0,0,0,.08.08.09.09,0,0,0,.11-.08c.56-4.84.91-9.66,1.24-14.49s.39-9.65.7-14.47A128.74,128.74,0,0,1,97,364.28,132.26,132.26,0,0,1,100.17,350.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.18,360.29a.11.11,0,0,0-.14,0,49,49,0,0,0-10.7,9.33,43.12,43.12,0,0,0-4.18,5.82L100.3,377l-.68,1.69a15,15,0,0,0-.58,1.71c-.18.57-.37,1.15-.52,1.72a68.62,68.62,0,0,0-2.22,14.12,82.41,82.41,0,0,0,.53,14.22.11.11,0,0,0,.09.08.09.09,0,0,0,.11-.09l1.22-14.07A123.31,123.31,0,0,1,100,382.53c.13-.57.29-1.12.43-1.68a15.86,15.86,0,0,1,.5-1.66l.57-1.62.73-1.54a41.79,41.79,0,0,1,3.84-5.82,48.3,48.3,0,0,1,10.05-9.78h0A.11.11,0,0,0,116.18,360.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43,378.37a15.7,15.7,0,0,0-4.87,5.85,34.93,34.93,0,0,0-2.72,7.17c-.19.61-.34,1.23-.48,1.86l-.44,1.87a32.59,32.59,0,0,0-.47,3.8c0,1.28,0,2.55,0,3.83a35,35,0,0,0,.5,3.8.13.13,0,0,0,.08.08.11.11,0,0,0,.12-.08,33.41,33.41,0,0,0,.67-3.74c.2-1.24.39-2.47.54-3.71s.34-2.45.44-3.68.26-2.47.53-3.68a33.09,33.09,0,0,1,2.09-7.1,15.63,15.63,0,0,1,4.08-6.1h0a.1.1,0,0,0,0-.13A.1.1,0,0,0,108.43,378.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,392.47c-.53-6.25-1.56-12.43-2.53-18.61s-2.06-12.35-3.19-18.5-2.39-12.28-3.72-18.4a.1.1,0,0,0-.19,0c1.07,6.16,2,12.34,3,18.52s1.82,12.36,2.6,18.56,1.36,12.41,2.14,18.6l2.28,18.6a.11.11,0,0,0,.1.08.11.11,0,0,0,.1-.09c.07-1.57.07-3.14.11-4.71s-.06-3.13-.09-4.7C86.49,398.72,86.22,395.6,86,392.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.24,392.38c-.33-2.47-.79-4.93-1.26-7.38l-.88-3.65c-.29-1.22-.56-2.44-.91-3.64a103.15,103.15,0,0,0-4.78-14.21l-.75-1.72-.83-1.68c-.53-1.13-1.17-2.21-1.78-3.3a27.63,27.63,0,0,0-4.51-6,.1.1,0,0,0-.13,0,.1.1,0,0,0,0,.14h0a27.66,27.66,0,0,1,4.12,6.11c.54,1.11,1.12,2.21,1.58,3.35l.74,1.7.65,1.74a101.86,101.86,0,0,1,4.16,14.21c.57,2.41,1,4.86,1.41,7.28l.59,3.66c.21,1.22.47,2.43.64,3.65.39,2.45.84,4.88,1.27,7.33s.82,4.89,1.34,7.34a.1.1,0,0,0,.1.08.09.09,0,0,0,.09-.09q0-3.75-.17-7.49C82.79,397.35,82.5,394.87,82.24,392.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,392.7c-1.16-3.28-2.5-6.49-4-9.63a85.72,85.72,0,0,0-5-9.13.11.11,0,0,0-.13,0,.1.1,0,0,0,0,.14,85.29,85.29,0,0,1,4.25,9.4c1.27,3.2,2.41,6.44,3.37,9.74s1.67,6.64,2.55,9.95,1.67,6.64,2.68,10a.1.1,0,0,0,.09.07.09.09,0,0,0,.1-.09,49.73,49.73,0,0,0-1-10.4A64.84,64.84,0,0,0,77.07,392.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86,403.62a23.16,23.16,0,0,0-2.75-5.77,24,24,0,0,0-4-5A18.81,18.81,0,0,0,67.56,391a10.62,10.62,0,0,0-2.89-1.31.1.1,0,0,0-.07.19h0a14.38,14.38,0,0,1,4.79,3.72,22.72,22.72,0,0,1,3.33,5.06c1,1.79,1.44,3.77,2.27,5.62.36.95.72,1.91,1.14,2.85A25.06,25.06,0,0,0,77.41,410h0a.11.11,0,0,0,.09.06.1.1,0,0,0,.1-.1,22.63,22.63,0,0,0-.12-3.19C77.33,405.7,77.11,404.66,76.86,403.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.24,345.91a17.79,17.79,0,0,1-12.6-13.39c-2.36-11,5.25-6.3-1.57-23.63s-5.25-21.26-2.89-26.25,3.67-3.41,5.77,3.15,9.72,16.8,12.6,36S77.24,345.91,77.24,345.91Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.46,327.27s-6.83-2.36-7.09-15.23,5-10.23,5.77-26.25,1.84-27.3,4.73-27.56S111.37,266.1,114,284s-3.41,29.67-8.66,34.92S97.46,327.27,97.46,327.27Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.57,361.4S72,352,68.84,347.48s-10-8.4-14.44-17.06-9.45-12.86-9.18-.53,5.77,18.64,12.6,22.84S73.57,361.4,73.57,361.4Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.68,377.67s-6.3-12.07-15.49-21-16.54-13.39-13.91-8.93,5.77,4.21,10.24,12.08,3.15,13.65,9.45,18.11S70.68,377.67,70.68,377.67Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.89,393.16c-.26-.79-.52-6.56-9.45-11.29s-17.32-2.89-16.27-.52,6.56,6.3,12.07,8.66S69.89,393.16,69.89,393.16Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,361.92s-3.94-5-1.84-15.49,6.83-7.87,12.08-13.39,4.2-6.3,9.45-12.07,10-8.93,12.07-6.56-1,9.71-4.2,13.91-8.13,6.3-10.5,11.55-1.31,13.65-7.35,17.59S96.93,361.92,96.93,361.92Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06,364.81s9.45-10.76,16.27-18.64,9.45-13.91,9.71-8.66,2.37,9.45-3.15,16.27S110.06,364.81,110.06,364.81Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,382.13s-.26-4.2,14.7-13.91,21.26-11.55,19.69-7.61-8.14,7.87-15.23,15S105.07,382.13,105.07,382.13Z",
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.87,344.79S74.35,326,70.68,312.57s-6-21.53-6-21.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85,327.47s6.38-20.41,8.48-32.75-.26-21.53-1.31-27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.74,361a99.72,99.72,0,0,0-9.67-13.78c-5.78-6.83-10.24-10.5-12.87-17.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,361.92s2.1-12.6,7.09-19.16,15-16.8,18.9-23.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.27,392.87s-8.83-5.75-15.13-8.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.85 462.12 76.13 462.12 70.83 403.43 106.15 403.43 100.85 462.12",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.32,
    y: 105.64,
    width: 247.36,
    height: 169.7,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.25,
    y: 109.73,
    width: 239.51,
    height: 161.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.02,
    y: 150.64,
    width: 35.2,
    height: 28.22,
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.43,
    y: 179.32,
    width: 35.2,
    height: 28.22,
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.02,
    y: 235.76,
    width: 35.2,
    height: 28.22,
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.31,
    y: 122.87,
    width: 35.2,
    height: 28.22,
    style: {
      fill: "#7BCDF1"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.88,
    y1: 126.97,
    x2: 272.88,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.14,
    y1: 126.97,
    x2: 309.14,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.41,
    y1: 126.97,
    x2: 345.41,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.67,
    y1: 126.97,
    x2: 381.67,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.94,
    y1: 126.97,
    x2: 417.94,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.2,
    y1: 126.97,
    x2: 454.2,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.47,
    y1: 126.97,
    x2: 490.47,
    y2: 263.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.79,
    y1: 150.64,
    x2: 490.93,
    y2: 150.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.79,
    y1: 178.86,
    x2: 490.93,
    y2: 178.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.79,
    y1: 207.09,
    x2: 490.93,
    y2: 207.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.79,
    y1: 235.31,
    x2: 490.93,
    y2: 235.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.17,
    y1: 155.65,
    x2: 373.02,
    y2: 155.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.17,
    y1: 159.29,
    x2: 373.02,
    y2: 159.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.17,
    y1: 162.93,
    x2: 373.02,
    y2: 162.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.17,
    y1: 166.57,
    x2: 373.02,
    y2: 166.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.17,
    y1: 170.21,
    x2: 373.02,
    y2: 170.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.41,
    y1: 186.15,
    x2: 411.26,
    y2: 186.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.41,
    y1: 189.79,
    x2: 411.26,
    y2: 189.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.41,
    y1: 193.43,
    x2: 411.26,
    y2: 193.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.41,
    y1: 197.07,
    x2: 411.26,
    y2: 197.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.41,
    y1: 200.71,
    x2: 411.26,
    y2: 200.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.08,
    y1: 242.14,
    x2: 373.93,
    y2: 242.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.08,
    y1: 245.78,
    x2: 373.93,
    y2: 245.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.08,
    y1: 249.42,
    x2: 373.93,
    y2: 249.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.08,
    y1: 253.06,
    x2: 373.93,
    y2: 253.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.08,
    y1: 256.7,
    x2: 373.93,
    y2: 256.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.46,
    y1: 130.61,
    x2: 446.31,
    y2: 130.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.46,
    y1: 134.25,
    x2: 446.31,
    y2: 134.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.46,
    y1: 137.89,
    x2: 446.31,
    y2: 137.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.46,
    y1: 141.53,
    x2: 446.31,
    y2: 141.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 424.46,
    y1: 145.18,
    x2: 446.31,
    y2: 145.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 674.81,
    y: 340.5,
    width: 10.67,
    height: 18.95,
    transform: "translate(1360.29 699.94) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.39,
    y: 264.92,
    width: 53.17,
    height: 81.34,
    rx: 15.63,
    transform: "translate(1361.94 611.18) rotate(180)",
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.91,458.73a4.52,4.52,0,1,1,4.51,4.51A4.51,4.51,0,0,1,696.91,458.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.7,458.73a4.52,4.52,0,1,1,4.51,4.51A4.51,4.51,0,0,1,608.7,458.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.12,458.73c0-2.5.94-4.52,2.1-4.52s2.1,2,2.1,4.52-.94,4.51-2.1,4.51S655.12,461.22,655.12,458.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "653.11 434.22 653.11 369.5 661.97 369.5 661.97 434.49 705.71 451.79 705.71 456.13 699.35 456.13 699.35 452.45 657.21 443.76 615.06 452.45 615.06 456.13 608.71 456.13 608.71 451.79 653.11 434.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.44 456.12 655 456.12 654.05 435.11 660.39 435.11 659.44 456.12",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.29,
    y: 367.03,
    width: 22.53,
    height: 13.38,
    transform: "translate(1315.11 747.45) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 618.12,
    y: 354.71,
    width: 80.98,
    height: 17.25,
    rx: 5.91,
    transform: "translate(1317.22 726.67) rotate(180)",
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.72,440.64a34,34,0,0,1-9.56,8.91c-5.65,3.25-14.33,4.56-14.33,6.29s.65,4.78,7.16,5.65,34.75,1.3,38.44.43.22-19.11.22-19.11S594.49,443.68,589.72,440.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573,461.49c6.52.87,34.75,1.3,38.44.43.94-.22,1.42-1.57,1.6-3.47-7.87.25-23.22.48-32.43,0-12.38-.65-14.77-2.61-14.77-2.61C565.83,457.58,566.48,460.62,573,461.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.17,270.82s1.74,25.63,3.26,36.49,7.17,55.15,10.86,66.66,7.6,61,7.6,61-4.13,1.52-3.91,3.25.43,4.35.43,4.35,8.47,4.56,13.47,4.56S613.17,445,613.17,445s-1.3-19.33-2-34.53-6.94-79.92-6.94-79.92L603,266.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.87,445.42s.44,4.13-10.42,7.82-12.16,7.6-10.86,10.86,23.89,3.25,32.36,1.95,12.81-1.74,13.46-3.47-1.74-15-1.74-15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.41,462.58a7.47,7.47,0,0,0,.06-2.33c-3,.55-7,1.3-12.22,2.33-11.6,2.25-26.9.92-34,.08a5.65,5.65,0,0,0,.37,1.44c1.3,3.25,23.89,3.25,32.36,1.95S630.76,464.31,631.41,462.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,277.12l6.3,7.6s4.77,52.55,6.51,66.24,10,62.54,10,62.54L606,439.56l-1.3,3.25a9.81,9.81,0,0,0,0,4.35c.22.87-.22,1.52,8,2.82a60.38,60.38,0,0,0,16.51,0,17.5,17.5,0,0,0,1.08-6.08,37.19,37.19,0,0,0-.65-8.47c-.65-3.47,0-21.93-4.77-41.69s-8.26-42.57-8.26-50.17.22-52.12.44-53,4.34-3.7,4.56-11.73-.87-11.08-.87-11.08H578.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.77,169.63S568,194,567.35,210s0,38.87.22,39.74-2.39,19.11-.87,21.93a3.48,3.48,0,0,0,4.12,2s47.56.65,49.73.21,2.61-3.25,3-5.43-1.3-28-1.3-31.92,1.3-47.56-4.13-59.72-18.89-22.15-20.63-22.58S581.68,158.55,577.77,169.63Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,121.8s-1.66,8-1.17,8.64,2.16,3.82,2.16,3.82l-4.32,11.8,5.16,1.49,7.31,12.63L574.45,157l3.33,15.12s-.5,5.48,2,4,4.65-3.16,9.47-11.47,9.63-9.63,9.63-9.63-6-8-7.14-10.47-.5-6.64-2.49-16.78-8.81-12.29-18.11-12.29S554.85,117.31,554,121.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.67,112.33s-7.48,1.66-8.81,3.16.67,6.14,2.5,7.14S566,121,565.81,121.8s-2,3,0,3.82,10,3,10,3l-2,15.29s-9.8-.5-12.13,0-5.81,3.65-5.81,3.65S560.16,160.68,561,162s3.15,1,5.81,0,13.46-8.81,14.62-9.81-1.33-10.8-1.33-10.8.33-8.14.33-9.8,2.16-1.66,3.66-.5,2,5.65,1.66,7.31a7.71,7.71,0,0,1-2.16,3.33s6.31,4.81,7.64,4.81a1.72,1.72,0,0,0,1.83-1.32c.17-.5-.17-14.79-.17-14.79s.34-13.62-1.49-17.94-10.47-5.49-15.95-4.66S558.67,112.33,558.67,112.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560,134.93c.16.91-.11,1.71-.61,1.8s-1-.58-1.19-1.48.12-1.71.62-1.79S559.83,134,560,134.93Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.34,131.6a3.41,3.41,0,0,1,4.66-.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.16,149.88s3.82-1.17,5-3.82",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.79,225s-9.34,41.48-10.21,43.65S591,279.51,591,279.51l10.21,8.9s1.52-2.39,2.82-8a68.28,68.28,0,0,0,1.52-11.08s14.77-31.48,17.15-35.83.66-7.6.66-8.68S605.79,225,605.79,225Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.05,177.66s-2.38,7.6-2.17,11.29,5.21,25.85,5.21,25.85-2.6,2.39-1.73,3.25a21.63,21.63,0,0,1,2.17,3s-2,1.52,0,3.7,1.08,3.25,10.2,3,11.95-.66,13-2.39,2.39-3,1.31-4.78L626,218.92a8.25,8.25,0,0,0,.87-4.34c-.22-2.39-1.74-5.21-1.74-6.3s-.21-15.85-3-27.36-14.76-17.81-16.94-18",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.09,287.13s.35,13.62.35,14.13-1.71,10.22-.86,14.82,7.67,10.9,7.67,10.9l.68-41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.64,193.2s-20,24.36-20.6,27.06-5.83,68.69-5.83,69.32,8.12,3.75,11.45,3.75h4.78s-5.62-45.38-3.12-62.24,8.54-21.65,13.12-28.1S496,191.54,491.64,193.2Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.69,441.74s-5.21,7.49-8.12,9.16-12.49,5.62-12.91,6.66-.41,3.54.42,3.75,15.19-.21,23.94-.21,14.57.41,15.61-.63.21-14.57-.84-17.27l-1-2.71-15.61-.42Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,459.22H471.39c0,1,.18,2,.69,2.09.83.2,15.19-.21,23.94-.21s14.57.41,15.61-.63A2.62,2.62,0,0,0,512,459.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.7,284.79l2.71,12.7s-.42,33.1,2.91,47.46a141.92,141.92,0,0,1,3.33,28.31s4.58,22.69,6.25,29.14,3.54,33.72,3.54,33.72-1.67,1.25-1.46,2.08.83,6,.83,6,.83,0,7.5.62a53.5,53.5,0,0,0,10.19.21l2.29-1.87a58,58,0,0,0,0-6.66c-.2-3.75-1.45-6.67-1.45-9.16s-1.46-57.45-1.46-57.45l.62-86.18-36.42-2.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.08,441.32a40.43,40.43,0,0,1-3.74,7.08c-1.88,2.5-9.58,6.87-12.7,8.53a6.25,6.25,0,0,0-3.12,5.21s7.07.21,30.39-.63l10-.41a31,31,0,0,0-.21-5.83c-.41-3.12-.83-11-.83-11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.91,461.51l10-.41a29,29,0,0,0,0-3.37l-39.84,2a6.63,6.63,0,0,0-.55,2.38S500.59,462.35,523.91,461.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,299.57l7.91,7.7s3.13,30,6.25,47.67,11.24,63.28,11.24,67,1.66,13.33,1.66,13.33-.62.2-.83,1.66S512,444,512,444a34.16,34.16,0,0,0,9.79,2.91,83,83,0,0,0,11.65-.2,63.35,63.35,0,0,0,.84-6.46c0-1.66-.63-8.95-.21-11.86s3.33-17.7,2.5-33.93-5.83-41.42-5.83-41.42l1.66-36.64a54.44,54.44,0,0,0,2.08-20.4c-1-11.24-3.53-15.61-3.53-15.61l-48.71.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.64,193.2S475,213.81,473.33,223s-4,61-4,63.07,3.33,2.91,7.29,3.54a95.57,95.57,0,0,0,17.07,1c6.86-.21,13.94-2.5,15-3.75s-1-38.09,2.5-58.28,7.08-31,5-35S498.72,189,491.64,193.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.5,192.16S496,214,493.73,229.42s-.63,66.82-.63,66.82,0,2.08,9.58,1.87,22.48-2.7,26-4.58,7.49-3.33,7.7-4.37-1.88-4.78-1.88-7.91-1.45-16-1.45-16-.42-56.82-3.54-64.94S514.12,189.87,508.5,192.16Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.11,153.24s-1.66,6.66-1,8.74a13,13,0,0,1,.63,5.2c-.21.84-5,6.25-4,7.29a32.2,32.2,0,0,0,3.54,2.71s1,11,2.92,11.65,8.74-.62,8.74-.62,2.29,8.53,2.29,10-7.08,17.07-3.12,15.82,19.77-24.15,19.77-24.15-.21-29.35-4.79-36.84S484.78,146.79,478.11,153.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.9,167.08c0,1.09-.42,2-.93,2s-.94-.89-.94-2,.42-2,.94-2S482.9,166,482.9,167.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.78,162.81a2.88,2.88,0,0,1,4.37.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.2,178.84a12.73,12.73,0,0,0,6-2.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.61,138s-10.2,4-11.24,7.7-1.88,8.12-1.88,8.12l9.16,1.88,7.91.62s-.21,1.87,2.08,6.24a76.16,76.16,0,0,1,3.33,7.08s-.62,12.28-1.24,15.82a59,59,0,0,1-2.09,7.7s5.21,1,14.78,2.09S527.86,194,527.86,194s2.5-4.17,2.29-12.49-4.16-20.19-4.58-25,.84-8.12-6.66-13.95S498.1,134.71,485.61,138Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.17,261.61a10.19,10.19,0,0,1-1.57-.11l.47-3c1,.15,3.26.14,3.95-.84.94-1.34.2-8.77-.75-10-.36-.42-2.07-.42-3.3-.13l-.69-2.93c.74-.17,4.52-.93,6.27,1.11s2.8,11,.92,13.7C471.18,261.27,468.78,261.61,467.17,261.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.39,
    y: 241.91,
    width: 17.9,
    height: 23.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.12,205.28s-3.53,7.91-3.74,11.86S514.75,248,514.75,248s-15,3.74-19.15,3.74a50.73,50.73,0,0,1-6.87-.41s-5.62-3.75-7.29-4.79-2.91-.42-5.82-2.71-5.21-2.49-5.42-1.24-.2,2.08,1.88,3.12a19.81,19.81,0,0,1,3.74,2.5s-5,1-6.45,1.25-1.87,2.28-1,3.33,2.29,2.49,2.29,2.49-.21,5,2.5,6,10.2.83,10.2.83,7.91.63,9.16.63,17.07,3.95,28.31,3.95,14.57.63,15.19-1.87-.42-39.34-2.5-50.58-6.87-17.49-10.2-17.9",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.52,250.7a44.74,44.74,0,0,1-6.92,1,50.73,50.73,0,0,1-6.87-.41s-5.62-3.75-7.29-4.79-2.91-.42-5.82-2.71-5.21-2.49-5.42-1.24-.2,2.08,1.88,3.12a19.81,19.81,0,0,1,3.74,2.5s-5,1-6.45,1.25-1.87,2.28-1,3.33,2.29,2.49,2.29,2.49-.21,5,2.5,6,10.2.83,10.2.83,7.91.63,9.16.63c.66,0,5.36,1.1,11.31,2.13C501.64,259.82,501.92,254.35,502.52,250.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.59,446.37a53.05,53.05,0,0,1-4,12.76c-3,6.37-3.19,8.77,3.59,9.76s10.16-.6,11.56-4.18,2-12.16,2.39-14.15S273.17,442.38,264.59,446.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.76,461.72c-1.4,2.59-3.19,5.78-10.37,5.18-4.07-.34-5.77-2.1-6.47-3.55-.92,3.3.27,4.81,5.28,5.54,6.77,1,10.16-.6,11.56-4.18a28.33,28.33,0,0,0,1.2-5.18C276.6,460.17,276.19,460.91,275.76,461.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,444.58a40.32,40.32,0,0,0,10.56,6.77c6.38,2.79,11,4.39,11,5.78a12.25,12.25,0,0,1-1.4,4,55.25,55.25,0,0,1-13.55,2c-6.78,0-12.36-.6-17.34-.8s-10.77.4-11.16-3.18.39-10.37.39-10.37S317,443.38,321,444.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.13,461.12s.35-.65.7-1.47a70.47,70.47,0,0,1-9.87,1.07c-7.17.2-9.76-.8-17.94-1.79a69.31,69.31,0,0,0-15,0c0,.05,0,.11,0,.17.39,3.58,6.18,3,11.16,3.18s10.56.8,17.34.8A55.25,55.25,0,0,0,341.13,461.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,288.28s1,30.15-.82,56.81-4.31,65.83-3.28,71.37S320,439.84,320,439.84l1.85,2.26,1,3.69s-1,1-7.38,2.87-15.59,2.26-15.59,2.26-.41-6.16-.41-7.8.41-5.33.41-5.33-3.48-43.27-2.87-52.09-.61-44.1-.61-44.1l-1-12.71s-8.2,33-8.61,37.12-6.16,45.94-6.16,48.4-2.46,25.84-2.46,25.84a11.81,11.81,0,0,1,1.64,4.51c.21,2.26-1.43,8-1.43,8a14.76,14.76,0,0,0-5.95-2.25l-8.41-.62s-1.64-11.9-1.64-14.36V422.82s-.82-29.33.62-40.61.61-46.14-.21-60.91-2.87-27.89-1.43-31.17a42.83,42.83,0,0,0,2.25-7.39,228.49,228.49,0,0,0,31.79,4.31c17,1,25.64-2.05,25.64-2.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 328.89,
    x2: 299.87,
    y2: 315.62,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,293.75s3.67.39,11.59-.77,11.19-2.9,11.19-2.9-5.21-100.57-5.21-101.54a6.09,6.09,0,0,0-5.4-6.47c-5.41-1-12.55,1.35-14.1,7.34S295,293.75,295,293.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.56,299s-.58,6,0,6.37,6.18-1.73,9.85-3.28,2.45-.93,3.63-4.42.81-3.49-2.86-2.53S317.56,299,317.56,299Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.9,200.56l4.32,58.21,2.24,42s.74,1.34,1.93,1.05,11.46-2.68,12.65-4.17,1.64-5.36,1.64-6-3.12-37.22-3.12-37.22l8-10.72s-6.11-33.49-7.6-40.19-1.48-10.27-3.87-13.25-16.08-9.68-16.08-9.68Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,177s5.51,5.8,5.36,8.78-3.73,14.74-3.73,14.74l-2.23-17.27S306.48,179,308.27,177Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.12,164.64l-.46,12.18s4,10,6.55,13,7.14,8,7.14,8l5.07-10.57.14-5.81,2.24-5.51a24.65,24.65,0,0,1-9.68-4.61c-4.76-3.72-9.68-8.19-10.12-8.34S290.12,164.64,290.12,164.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.12,169s1.29,4.73,9.46,10.32a23.94,23.94,0,0,0,6,3.08l0-.92,2.24-5.51a24.65,24.65,0,0,1-9.68-4.61c-1.21-.95-2.42-1.94-3.58-2.89L296,168Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.12,138.6s-.53,12.48-.89,16.77-.54,8-2.5,11.95-4.1,10-7.49,10.52a19.29,19.29,0,0,1-12.48-2.32c-4.11-2.5-9.46-9.45-9.64-10.88a9.89,9.89,0,0,0-.53-2.32s-2.14-12.84-2.14-18.55.53-10.52,9.63-13.73S323.12,138.6,323.12,138.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.33,138.6s5.53,1.43,2.68,3.92-5.53,5.35-5.53,5.35.89,3.57.54,5-2.14,2.5-3.39,1.07-2.32-2.5-2.32-2.5-3.39-10.7-4.1-13.73-1.43-6.25,3-9.28a46.09,46.09,0,0,1,5.35-3.39,30.13,30.13,0,0,1,17.84-4.1c10.34.89,15,6.78,15,6.78s8.2-2.14,7.67,3.74-6.42,9.81-9.63,9.46-20.16-8.92-23.55-7.49S291,138.06,293.33,138.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.85,151.8s2.49,8,1.78,8.74-3.57,1.25-3.57,1.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,165.18s-5.71,1.6-10-1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.56,146.8s-7.52-.71-11.45-.71-5.35-.36-5.53.71-.53,6.78,2.5,8.74,8.56,1.07,10.88.54,3-4.46,3.21-5.71S311.56,146.8,311.56,146.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.77,146.82s6-.38,9.09-.22,4.24-.12,4.38.92.43,6.55-2,8.31-6.79.68-8.64.07-2.4-4.42-2.54-5.63S313.77,146.82,313.77,146.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.58,
    y1: 146.8,
    x2: 285.31,
    y2: 151.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.56,
    y1: 146.8,
    x2: 313.96,
    y2: 146.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,155.9s-4.1-5.17-7-4.46-.35,8.21,2,9.45,4.81-.35,4.81-.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.84,151.58c0,1-.43,1.86-1,1.86s-1-.83-1-1.86.43-1.86,1-1.86S304.84,150.55,304.84,151.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.17,
    cy: 151.58,
    rx: 0.97,
    ry: 1.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.63,145a16.57,16.57,0,0,1,9.08.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,145.4a8.73,8.73,0,0,1,5.51-.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.78,303.21l.21,3.67s-8.49,1.73-20.27-1-22.39-10-23.55-11.58,1-8.11,1-8.11-1.55-.38,1.16.58,13.32,10.23,27.79,12.74S300,301.09,299.78,303.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.76,173.09s7.3,10.13,10.72,14.74,2.53,10.27,2.09,11.76-1,4-1,4V297.7s1.34,5.06-.75,5.51-17.27-.3-28.43-6.1-15-9.83-15-9.83l2.83-22.93,1.19-12.8-18.46.09s10.87-52.2,12.06-55,30.52-17.72,30.52-17.72S284.89,174.06,288.76,173.09Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.7,
    y1: 215.32,
    x2: 325.46,
    y2: 212.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.56,
    y1: 254.45,
    x2: 326.07,
    y2: 219.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260.33,
    y1: 251.55,
    x2: 263.8,
    y2: 218.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,244.66a21,21,0,0,0-7.83,0c-4.51.8-6.63,9.16-6.9,12.08s1.59,8,5,9.42,5.18,1.32,8.76-.8,3.19-11.94,3-15.26A9.05,9.05,0,0,0,255.33,244.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,235.06s1.32-8.9,1.46-11.81-.27-6.51.26-7.7,2.39-.13,3.05.66,1.2,4.91,1.07,6.5a16.91,16.91,0,0,0,0,2.92s10.21-7.56,11.41-9.15,3.58-2.79,4.38-1.73-.14,2-1.07,2.92-5.7,6.37-6.5,7a3.7,3.7,0,0,0-1.06,1.72,4.55,4.55,0,0,0,2-.27c1.2-.39,9.42-4.51,10.22-4.51a1.47,1.47,0,0,1,1.19,1.86c-.26.8-10.35,6.9-10.74,7s-.8,1.07-.14,1.2,8.89-1.2,9.95-.67a1.27,1.27,0,0,1,.27,2.13c-.53.4-10.35,2.12-10.35,2.12l4.51.93c1.33.27,3.58.27,3.58,1.06s-.53,1.2-1.46,1.2h-6.9c-1.46,0-4.37,1.19-6.76,2.25s-3.45,1.46-3.45,1.46-6.51,11.81-8.89,16.06a11.4,11.4,0,0,1-9.43,6.1c-3.45.27-7-6-6.36-9s6.23-9.82,11.14-12.34S261.88,238,264.14,235.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.24,246.2s-3.79-4.93-6.45-5.12-7.4,8.34-7.4,11.95.19,10.43,1.71,11.38,4.36-.76,6.07-3S343.24,246.2,343.24,246.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.74,222.8s.22-4.06-.55-3.84-1.31.77-1.09,2.63a27.09,27.09,0,0,1-.66,5.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.36,244.84s-6,11-5.81,13.93,2.74,4,7.35,2.63,36.74-18.86,38.27-20.29,6.8-12.39,8.56-14.37,1.53-6.9,1.53-7.78-1.53-.55-1.53.55-3.73,8.22-4.28,8.44-5.48,2.63-5.48,2.63,2.52-4.93,3.4-6.58,1.64-3.51-.22-2.85-4.83,5.7-5.93,8.45-3,6.36-2.63,8.11l.33,1.76s-11.08,2.52-17.66,2.85S339.69,243.74,339.36,244.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.78,233.22s5.81-6.7,6.58-7.9,1.75-3.07,1.53-4.5-1.2.33-2,1.54-2.3,2.3-3.18,4.27a4.88,4.88,0,0,1-3,2.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,237.27s3.29-6.8,4.16-8.66,1.1-5.05,1.21-7-1.54-.66-1.76,1-1.53,6.58-1.53,6.58-7.13,5-7.13,6.36a30.33,30.33,0,0,0,.22,3.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.48,
    y: 340.5,
    width: 10.67,
    height: 18.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.41,
    y: 264.92,
    width: 53.17,
    height: 81.34,
    rx: 15.63,
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.06,458.73a4.52,4.52,0,1,0-4.51,4.51A4.51,4.51,0,0,0,136.06,458.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.27,458.73a4.52,4.52,0,1,0-4.51,4.51A4.51,4.51,0,0,0,224.27,458.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,458.73c0-2.5-.94-4.52-2.09-4.52s-2.1,2-2.1,4.52.94,4.51,2.1,4.51S177.84,461.22,177.84,458.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.85 434.22 179.85 369.5 170.99 369.5 170.99 434.49 127.26 451.79 127.26 456.13 133.61 456.13 133.61 452.45 175.76 443.76 217.9 452.45 217.9 456.13 224.26 456.13 224.26 451.79 179.85 434.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.53 456.12 177.96 456.12 178.91 435.11 172.58 435.11 173.53 456.12",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.14,
    y: 367.03,
    width: 22.53,
    height: 13.38,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.86,
    y: 354.71,
    width: 80.98,
    height: 17.25,
    rx: 5.91,
    style: {
      fill: "#949494",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,402.5l6.89,10.22,8.17-.51s15.57-2.81,17.61-3.32,2.81,1.27,1.79,3.32-10.47,11.23-15.06,14-17.62,7.4-18.89,7.66-2.81-2.3-5.62-10.21a89.23,89.23,0,0,0-7.91-15.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.36,412.21c1-2,.26-3.83-1.79-3.32S289,412.21,289,412.21l-8.17.51a21.23,21.23,0,0,0,1.28,6.89s-11.49,2.81-13.28,4.09c2.81,7.91,4.34,10.46,5.62,10.21s14.29-4.85,18.89-7.66S307.34,414.25,308.36,412.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.36,412.21a3.33,3.33,0,0,0,.36-2.3c-4.67,3.93-14.44,12-18.35,13.95-3.73,1.86-13.41,5.27-18.68,7.08,1.13,2.29,2,3.12,2.72,3,1.27-.26,14.29-4.85,18.89-7.66S307.34,414.25,308.36,412.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.46,318.17s11.24,33,17.78,55.23A225.31,225.31,0,0,0,278,404.55s-5.36,3.06-8.94,4.85-9.7,4.08-9.7,4.08-4.85-7.66-9.95-17.61-13.79-34.21-17.88-41.62-9.7-18.64-9.7-18.64-2.55-12.76,7.15-16.08S245.66,314.6,248.46,318.17Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,312.65s4.4,2.93,4.52,3.41-.12.86-1.1,1.23-5.49,1.22-5.49,1.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.05,423.47s-1.76,10.95-3,14.94-4.48,11.26-3.45,13.06,6.48,3.66,9.26,3.89,6.34,4.78,11.51,6.65,12,1.37,11.85,0-15.31-18-16.05-22.1,1.91-16.74,1.91-16.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.32,442.62l-.41,1.15a70.75,70.75,0,0,1-11.82-2.38c-1.41,3.91-3.25,8.67-2.44,10.08,1,1.81,6.48,3.66,9.26,3.89s6.34,4.78,11.51,6.65,12,1.37,11.85,0-15.31-18-16.05-22.1A10.66,10.66,0,0,0,234.32,442.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.11,459.3c-4.09-2-7.79-5.44-13.24-7.28-3.54-1.21-6-2.18-7.3-2.72a3.55,3.55,0,0,0,.08,2.17c1,1.81,6.48,3.66,9.26,3.89s6.34,4.78,11.51,6.65c4.94,1.8,11.36,1.41,11.81.19C248.82,461.7,242.92,460.68,240.11,459.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,341.23s20.17,2.3,21.71,12.51S243,427.52,243,427.52a43.94,43.94,0,0,1-8.93-.51c-4.09-.76-11-2.29-11-2.29s-1-21.7-2.3-30.39-2.3-33.95-2.3-33.95-33.7-2.81-36.76-4.85S223.34,341.23,223.34,341.23Z",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.3,336.12s-45.19,17.62-56.68,21.45a54.27,54.27,0,0,1-31.91.26c-7.91-2.56-11.8-12.72-11.8-12.72s-2-2.35-1-4.64,17.37-16.86,27.32-19.41,28-1.44,28-1.44,38.92-9,44.28-8.26,9.63,19.85,10.39,22.4",
    style: {
      fill: "#7BCDF1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.45,347.1s3.58-14,13-19.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,337.66s3.83-5.88,8.94-7.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,232.51a10.09,10.09,0,0,1,6.47,4.8c2.51,4.18,6.69,19.85,6.69,19.85s6.68,19.43,5.43,24-6.27,11.28-6.27,11.28.42,15,1.67,18a76.38,76.38,0,0,1,2.72,9.19s-3.55,2.51-15.25,4.18-21.31,2.51-25.28,5.64-12.74,15-13.79,15.67-2.71,1.88-3.55.21-2.3-5.22-.42-12.74,5.23-37.19,6.48-51.19-1.46-28.2.21-38,16.5-15.66,19.84-16.29S182.52,232.51,182.52,232.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.26,332.55s6.39-7.4,9.45-8.68,24.51-1.28,24.51-1.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.86,323.1a25.19,25.19,0,0,1,6.38-2.55c2.81-.51,10.21,0,10.21,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.09,297.57a55.89,55.89,0,0,0,18.64-12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.07,173.18s3.13,6.69,4.18,8.77.62,5.65,1.46,8.57,5.64,4.8,5.64,6.48-1.88,5-1.88,5-1.05,13-2.72,14.41-8.56,1.88-8.56,1.88l-3.55,13.58,3.55,2.09s.62,12.33,0,16.72-.21,8.56-6.48,6.89S161.83,239.2,161,237.11s2.71-11.08-1.46-24.45,5-25.48,11.07-31.12S179.59,172.14,186.07,173.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.07,173.18c-.21-3.76-.63-5.22-8.36-6.06s-24.23-1.46-30.71,10-6.47,36.56-6.47,36.56S126.74,226,125.69,233.55s4,14.63,11.91,17.14l.47.12a23.73,23.73,0,0,1,4.33-9.63c4.52-5.42,8.44-4.82,14.16-6.33s9.36-1.89,10.21-8.42,2.09-13.59,1.54-20.24c-.21-2.51,2.51-6.27,2.51-6.27s6.47,1.67,10.65-9.61S186.28,176.94,186.07,173.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.53,203.05s-2.09-9.61-7.52-5.85,2.72,14.42,4,14.63,3.34-1.05,3.34-1.05",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.19 218.3 177.71 217.47 182.31 223.53 184.19 218.3",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,192.91c.27,1.42,0,2.67-.63,2.79s-1.35-.94-1.63-2.35,0-2.66.64-2.78S190.79,191.5,191.06,192.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25,306.78a10.6,10.6,0,0,0,1.6-.11l-.48-3c-1,.15-3.32.14-4-.85-.95-1.37-.2-8.93.77-10.21.36-.42,2.1-.42,3.35-.13l.7-3c-.75-.18-4.59-1-6.38,1.12s-2.85,11.2-.93,13.94C200.17,306.43,202.62,306.78,204.25,306.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.13,
    y: 286.75,
    width: 18.2,
    height: 23.71,
    transform: "translate(426.46 597.2) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.44,236.66s-9.64-3-14.05,15.63c-1.46,6.2-7.41,69-6.17,69.42,4.5,1.59,51.91-13.16,51.91-13.16s14.67-1,16-1.31,3.3-2.61,3.21-3.9,0-3.9,0-3.9,2.21-2.54,1.44-4.22a4.41,4.41,0,0,0-2.32-2.23h-3l-1.79-.74s2.23-2.32,1.86-4.46-2.17-3.32-2.93-1.76-.91,2.67-2.33,4.07a32.38,32.38,0,0,0-4.44,4.85c-1,1.59-3.73,5.68-3.73,5.68l-34.16,1.86L156,263.11",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.68,295.22a4.41,4.41,0,0,0-2.32-2.23h-3l-1.79-.74s2.23-2.32,1.86-4.46-2.17-3.32-2.93-1.76-.91,2.67-2.33,4.07a32.38,32.38,0,0,0-4.44,4.85c-1,1.59-3.73,5.68-3.73,5.68l-34.16,1.86,2.26-17.15-19.18-.44c-1.75,18-3.34,36.58-2.67,36.82,4.5,1.59,51.91-13.16,51.91-13.16s14.67-1,16-1.31,3.3-2.61,3.21-3.9,0-3.9,0-3.9S204.45,296.9,203.68,295.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.15,312.38s-3.83.77-4.85,2-3.57,8.17-2.29,8.43,3.83-5.36,3.83-5.36S206,313.91,202.15,312.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.86,312.4a5.18,5.18,0,0,0-2.56.49c-1.1.61-3.42,5.86-3.78,7.33s0,2.92,1,2.56,4.4-5.62,5.37-6.23S205.57,312.42,203.86,312.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.55,312.4a1.47,1.47,0,0,0-2.69,0c-1.46,2.08-3.9,8.43-3.29,8.91s2.07-1.09,3.05-2.19S207.28,315.21,206.55,312.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,312.65s-2.19-1.35-3.17-.25-1.71,7-1.47,7.57,2.2-.85,2.57-1.46S209.72,312.65,209.72,312.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingBro);
export default __webpack_public_path__ + "static/media/meeting-bro.01063e742be487c3697d7273977f6002.svg";
export { ForwardRef as ReactComponent };